import { useBreakpoint as useChakraBreakpoint } from "@chakra-ui/react";

export interface UseBreakpointReturn {
   isMobile: boolean;
   isTablet: boolean;
   isDesktop: boolean;
}

const useBreakpoint = (): UseBreakpointReturn => {
   const bp = useChakraBreakpoint({ ssr: false });

   switch (bp) {
      case "base":
      case "sm":
         return {
            isMobile: true,
            isTablet: false,
            isDesktop: false,
         };
      case "md":
         return {
            isMobile: false,
            isTablet: true,
            isDesktop: false,
         };
      case "lg":
         return {
            isMobile: false,
            isTablet: true,
            isDesktop: true,
         };
      default:
         return {
            isMobile: false,
            isTablet: true,
            isDesktop: false,
         };
   }
};

export default useBreakpoint;
